import { render } from "./ListGroup.vue?vue&type=template&id=18d653c5&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"

import "./ListGroup.vue?vue&type=style&index=0&id=18d653c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d653c5"]])

export default __exports__